import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class IntroService {

    constructor(public af: AngularFireDatabase, private loadingService: LoadingService) {}

    // Set data for - WIZARD MAIN
    getData = (): any => {
        return {
          'btnPrev': 'Previous',
          'btnNext': 'Next',
          'btnFinish': 'Finish',
          'icon': 'arrow-undo',
          'title': 'Fortuitu ad aeroportus',
          'description': `Morbi lacinia interdum nulla penatibus amet nibh adipiscing semper ligula,
                    tempor sed do eiusmod incididunt ut labore et dolore magna aliqua. Ut enim ad minima veniam`,
          'items': [
            {
              'backgroundImage': 'assets/imgs/background/11.jpg',
            },
            {
              'backgroundImage': 'assets/imgs/background/12.jpg',
            },
            {
              'backgroundImage': 'assets/imgs/background/13.jpg',
            }
          ]
        };
    }

    load(): Observable<any> {
        const that = this;
        that.loadingService.show();
        if (AppSettings.IS_FIREBASE_ENABLED) {
            return new Observable(observer => {
                this.af
                    .object('intro')
                    .valueChanges()
                    .subscribe(snapshot => {
                        that.loadingService.hide();
                        observer.next(snapshot);
                        observer.complete();
                    }, err => {
                        that.loadingService.hide();
                        observer.error([]);
                        observer.complete();
                    });
            });
        } else {
            return new Observable(observer => {
                that.loadingService.hide();
                observer.next(this.getData());
                observer.complete();
            });
        }
    }
}
